import { cn } from "@/utils/cn";
import { memo } from "react";
import { SubCardTitle } from "./sub-card-title";

interface SubCardProps {
  title: string;
  className?: string;
  children: React.ReactNode;
}
export const SubCard = memo(function SubCard({ title, className, children }: SubCardProps) {
  return (
    <div
      className={cn(
        "shadow-card flex w-full flex-col items-center gap-4 rounded-4xl bg-white px-3 py-4.5",
        className,
      )}
    >
      <SubCardTitle title={title} />
      {children}
    </div>
  );
});
